import { get } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';

import ProductListItem from './ProductItem';
import imageVariationsUrl from '../../helpers/image_variations';

export default class CompositesProductListItem extends Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { availabilityOpen: false };
  }

  render() {
    const { product } = this.props;
    const documents = get(product.documents, 'featured_document_1', []).concat(
      get(product.documents, 'featured_document_2', [])
    );

    const product_thumb = product.images && product.images.product_thumb;
    const teaser_copy = product.teaser_copy && product.teaser_copy.value;
    const product_url =
      product.legacy_links && product.legacy_links.value
        ? product.legacy_links.value
        : `${this.props.product_path}${product.slug}`;
    const availability =
      product.availability_details_table_name || product.availability_details_description ? true : null;

    return (
      <ProductListItem
        key={product.uid}
        preheading={(product.categories || []).map(category => category.name).join(', ')}
        heading={product.proper_name}
        url={product_url}
        img={product_thumb ? imageVariationsUrl(product_thumb, { screen: 'mobile', resolution: 1 }) : null}
        text={teaser_copy || null}
        documents={documents}
        availability={
          availability
            ? {
                title: product.availability_details_table_name ? product.availability_details_table_name.value : null,
                description: product.availability_details_description
                  ? product.availability_details_description.value
                  : null,
                table: product.availability_details_table ? product.availability_details_table.value : null,
                open: this.state.availabilityOpen,
                onOpen: () => {
                  this.setState({ availabilityOpen: true });
                },
                onClose: () => {
                  this.setState({ availabilityOpen: false });
                },
              }
            : null
        }
      />
    );
  }
}
